import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "labelKey", "valueKey", "options", "prefixIcon", "suffixIcon", "checkable", "deletable", "disabled", "onDelete", "onChange"];
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useState, useEffect, useRef } from 'react';
import { EmbersMenuItem } from '../menuItem/menuItem';
import { useMenusScroll } from './useMenusScroll';
import { StyledMenuList } from './menuListStyles';

// EmbersMenuOptionsList is an
//  alternate way of doing what the EmbersMenuList does, but
//  it builds the EmbersMenuItems from a list of key/value pairs
//  passed in as the "options" prop.  (The EmbersMenuList requires
//  the client to create the EmbersMenuItems and pass them in as
//  children.)  EmbersMenuOptionsList is not currently used by
//  anything.
export var EmbersMenuOptionsList = function EmbersMenuOptionsList(_ref) {
  var value = _ref.value,
    labelKey = _ref.labelKey,
    valueKey = _ref.valueKey,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    prefixIcon = _ref.prefixIcon,
    suffixIcon = _ref.suffixIcon,
    checkable = _ref.checkable,
    deletable = _ref.deletable,
    disabled = _ref.disabled,
    onDelete = _ref.onDelete,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var refMenuList = useRef(null);
  useMenusScroll(refMenuList);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedValues = _useState2[0],
    setSelectedValues = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedOptions = _useState4[0],
    setSelectedOptions = _useState4[1];
  useEffect(function () {
    var passedValues = value ? typeof value === 'string' ? [value] : value : [];
    setSelectedValues(passedValues);
    setSelectedOptions(options.filter(function (v) {
      return passedValues.includes(v[valueKey]);
    }));
  }, [value]);
  var omitUnselectedOption = function omitUnselectedOption(options, values, value) {
    var index = options.findIndex(function (v) {
      return v[valueKey] === value;
    });
    return {
      options: options.slice(0, index).concat(options.slice(index + 1)),
      values: values.slice(0, index).concat(values.slice(index + 1))
    };
  };
  var handleMenuItemClicked = function handleMenuItemClicked(evt, optionIndex) {
    var option = options[optionIndex];
    if (checkable) {
      var selectedOptionsRes, selectedValuesRes;
      if (!selectedOptions.includes(option)) {
        selectedOptionsRes = [].concat(_toConsumableArray(selectedOptions), [option]);
        selectedValuesRes = [].concat(_toConsumableArray(selectedValues), [option[valueKey]]);
      } else {
        var res = omitUnselectedOption(selectedOptions, selectedValues, option[valueKey]);
        selectedOptionsRes = res.options;
        selectedValuesRes = res.values;
      }
      setSelectedOptions(selectedOptionsRes);
      setSelectedValues(selectedValuesRes);
      onChange === null || onChange === void 0 || onChange(selectedValuesRes, selectedOptionsRes, evt);
    } else {
      onChange === null || onChange === void 0 || onChange(option[valueKey], option, evt);
    }
  };
  var renderItems = function renderItems() {
    return options.map(function (v, optionIndex) {
      return /*#__PURE__*/React.createElement(EmbersMenuItem, _extends({}, v, {
        key: v[valueKey],
        value: v[valueKey],
        label: v[labelKey],
        prefixIcon: prefixIcon,
        suffixIcon: suffixIcon,
        checkable: checkable,
        deletable: deletable,
        disabled: disabled,
        selected: selectedValues.includes(v[valueKey]),
        onClick: function onClick(e) {
          handleMenuItemClicked(e, optionIndex);
        },
        onDelete: onDelete
      }));
    });
  };
  return /*#__PURE__*/React.createElement(StyledMenuList, _extends({}, props, {
    ref: refMenuList
  }), renderItems());
};